import React from 'react';
import PropTypes from 'prop-types';

import Button from 'relements/build/esm/ui/button';

import { captureException } from '@src/api';

import styles from './ErrorBoundary.scss';

/**
 * Error boundary to catch derivative erros
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || this.renderFallback();
    }

    return this.props.children;
  }

  /**
   * renders fallback message if the user doesn't provide one
   */
  renderFallback = () => {
    return (
      <div className={styles.fallbackWrapper}>
        <div className={styles.fallback}>
          <div className={styles.fallbackMsg}>
            Unable to load module due to poor internet connection.
          </div>
          <Button
            className={styles.fallbackButton}
            type={Button.TYPES.PRIMARY}
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
        </div>
      </div>
    );
  };
}

ErrorBoundary.propTypes = {
  fallback: PropTypes.node,
  children: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  fallback: null,
  children: null,
};

export default ErrorBoundary;
